abstract class LoopBackEndpoint {
  public getIndexKey = (): string => this.indexKey;
  public getEndPoint = (): string => `${this.endPoint}`;
  public getCountEndPoint = (): string => {
    if (this.countEndPoint === '') {
      return '';
    }
    return `${this.getEndPoint()}/${this.countEndPoint}`;
  };
  public getRelationEndPoint = (
    id: string | number,
    relation: string,
    foreignKey: string | number
  ) => {
    return `${this.getEndPoint()}/${id}/${relation}/rel/${foreignKey}`;
  };
  public getPatchEndPoint = (id: string | number) => `${this.getEndPoint()}/${id}`;
  protected indexKey: string;
  protected endPoint: string;
  protected countEndPoint: string;

  protected constructor(endPoint: string, indexKey: string, countEndPoint = '') {
    this.endPoint = endPoint;
    this.indexKey = indexKey;
    this.countEndPoint = countEndPoint;
  }

  public abstract update(changedData: {}, rowData): Promise<any>;

  protected abstract getBaseFields(): string[];

  protected abstract getRelationFields(): string[];

  protected pickMatching(object, fields) {
    const obj = {};
    for (const path of fields) {
      if (object[path]) {
        obj[path] = object[path];
      }
    }
    return obj;
  }
}

export default LoopBackEndpoint;
